import { isBrowser as e } from "./highrise1284.mjs";
const t = e && "loading" in document.createElement("img");
export {
  t as isImageSupportNativeLazy
};
